/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BenchmarkAdaptersResponse,
  BenchmarkDetailResponse,
  BenchmarkFormatRequest,
  BenchmarkFormatRequestResponse,
  BenchmarkIngestionCreate,
  BenchmarkIngestionResponse,
  BenchmarkRename,
  BenchmarkRenameResponse,
  BenchmarksListResponse,
  GithubBenchmarkCreate,
  GithubBenchmarkResponse,
  HTTPValidationError,
  RolloutDetailResponse,
  RolloutListResponse,
  SourceAccessCheckResponse,
  TaskProcessResponse,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listBenchmarksApiBenchmarksGetResponse200 = {
  data: BenchmarksListResponse;
  status: 200;
};

export type listBenchmarksApiBenchmarksGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listBenchmarksApiBenchmarksGetResponseSuccess =
  listBenchmarksApiBenchmarksGetResponse200 & {
    headers: Headers;
  };
export type listBenchmarksApiBenchmarksGetResponseError =
  listBenchmarksApiBenchmarksGetResponse422 & {
    headers: Headers;
  };

export type listBenchmarksApiBenchmarksGetResponse =
  | listBenchmarksApiBenchmarksGetResponseSuccess
  | listBenchmarksApiBenchmarksGetResponseError;

export const getListBenchmarksApiBenchmarksGetUrl = () => {
  return `/api/benchmarks`;
};

/**
 * Every benchmark exported for the caller's team.
 *
 * A team without gateway credentials has no slug and therefore no bucket
 * prefix — that's an empty list, not an error, so the merged /evals page
 * renders for brand-new teams.
 * @summary List Benchmarks
 */
export const listBenchmarksApiBenchmarksGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listBenchmarksApiBenchmarksGetResponse> => {
  return orvalFetch<listBenchmarksApiBenchmarksGetResponse>(
    getListBenchmarksApiBenchmarksGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListBenchmarksApiBenchmarksGetQueryKey = () => {
  return [`/api/benchmarks`] as const;
};

export const getListBenchmarksApiBenchmarksGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBenchmarksApiBenchmarksGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>
  > = ({ signal }) =>
    listBenchmarksApiBenchmarksGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBenchmarksApiBenchmarksGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>
>;
export type ListBenchmarksApiBenchmarksGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListBenchmarksApiBenchmarksGet<
  TData = Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
          TError,
          Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListBenchmarksApiBenchmarksGet<
  TData = Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
          TError,
          Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListBenchmarksApiBenchmarksGet<
  TData = Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Benchmarks
 */

export function useListBenchmarksApiBenchmarksGet<
  TData = Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBenchmarksApiBenchmarksGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListBenchmarksApiBenchmarksGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type validateIngestionSourceApiBenchmarksIngestionsValidatePostResponse200 =
  {
    data: SourceAccessCheckResponse;
    status: 200;
  };

export type validateIngestionSourceApiBenchmarksIngestionsValidatePostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type validateIngestionSourceApiBenchmarksIngestionsValidatePostResponseSuccess =
  validateIngestionSourceApiBenchmarksIngestionsValidatePostResponse200 & {
    headers: Headers;
  };
export type validateIngestionSourceApiBenchmarksIngestionsValidatePostResponseError =
  validateIngestionSourceApiBenchmarksIngestionsValidatePostResponse422 & {
    headers: Headers;
  };

export type validateIngestionSourceApiBenchmarksIngestionsValidatePostResponse =
  | validateIngestionSourceApiBenchmarksIngestionsValidatePostResponseSuccess
  | validateIngestionSourceApiBenchmarksIngestionsValidatePostResponseError;

export const getValidateIngestionSourceApiBenchmarksIngestionsValidatePostUrl =
  () => {
    return `/api/benchmarks/ingestions/validate`;
  };

/**
 * The Check access preflight (TRA-1013). Staff only.
 *
 * Runs the exact submit-time checks (assume role, list the path,
 * non-empty, sampled-format parse) and nothing else — no ingestion row,
 * no side effects.
 * @summary Validate Ingestion Source
 */
export const validateIngestionSourceApiBenchmarksIngestionsValidatePost =
  async (
    benchmarkIngestionCreate: BenchmarkIngestionCreate,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<validateIngestionSourceApiBenchmarksIngestionsValidatePostResponse> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Symbol.iterator in h) {
        return Object.fromEntries(
          Array.from(
            h as Iterable<Iterable<string>>,
            (entry) => Array.from(entry) as [string, string],
          ),
        );
      }
      const headers: Record<string, string | readonly string[]> = {};
      for (const [name, value] of Object.entries<
        string | readonly string[] | undefined
      >(h)) {
        if (value !== undefined) headers[name] = value;
      }
      return headers;
    };
    return orvalFetch<validateIngestionSourceApiBenchmarksIngestionsValidatePostResponse>(
      getValidateIngestionSourceApiBenchmarksIngestionsValidatePostUrl(),
      {
        ...options,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(benchmarkIngestionCreate),
      },
    );
  };

export const getValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationKey =
  () => ["validateIngestionSourceApiBenchmarksIngestionsValidatePost"] as const;

export const getValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof validateIngestionSourceApiBenchmarksIngestionsValidatePost
        >
      >,
      TError,
      ValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof validateIngestionSourceApiBenchmarksIngestionsValidatePost
      >
    >,
    TError,
    ValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof validateIngestionSourceApiBenchmarksIngestionsValidatePost
        >
      >,
      ValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return validateIngestionSourceApiBenchmarksIngestionsValidatePost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof validateIngestionSourceApiBenchmarksIngestionsValidatePost
      >
    >
  >;
export type ValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationBody =
  BenchmarkIngestionCreate;
export type ValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationError =
  ErrorType<HTTPValidationError>;
export type ValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationVariables =
  { data: BenchmarkIngestionCreate };

/**
 * @summary Validate Ingestion Source
 */
export const useValidateIngestionSourceApiBenchmarksIngestionsValidatePost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof validateIngestionSourceApiBenchmarksIngestionsValidatePost
        >
      >,
      TError,
      ValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof validateIngestionSourceApiBenchmarksIngestionsValidatePost
    >
  >,
  TError,
  ValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationVariables,
  TContext
> => {
  return useMutation(
    getValidateIngestionSourceApiBenchmarksIngestionsValidatePostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponse200 = {
  data: BenchmarkFormatRequestResponse;
  status: 200;
};

export type requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponseSuccess =
  requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponse200 & {
    headers: Headers;
  };
export type requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponseError =
  requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponse422 & {
    headers: Headers;
  };

export type requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponse =
  | requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponseSuccess
  | requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponseError;

export const getRequestBenchmarkFormatApiBenchmarksFormatsRequestPostUrl =
  () => {
    return `/api/benchmarks/formats/request`;
  };

/**
 * Ask for support of a new rollout format on a team's behalf. Staff only.
 *
 * Fires one Slack event to #platform with the sample path and the
 * caller's identity. send_soon, never awaited — the user is waiting on
 * this response and the webhook must not be able to slow it (TRA-924).
 * The webhook URL never reaches the browser; this endpoint is the only
 * bridge from the web app to notifications.
 * @summary Request Benchmark Format
 */
export const requestBenchmarkFormatApiBenchmarksFormatsRequestPost = async (
  benchmarkFormatRequest: BenchmarkFormatRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<requestBenchmarkFormatApiBenchmarksFormatsRequestPostResponse>(
    getRequestBenchmarkFormatApiBenchmarksFormatsRequestPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(benchmarkFormatRequest),
    },
  );
};

export const getRequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationKey =
  () => ["requestBenchmarkFormatApiBenchmarksFormatsRequestPost"] as const;

export const getRequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof requestBenchmarkFormatApiBenchmarksFormatsRequestPost>
      >,
      TError,
      RequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof requestBenchmarkFormatApiBenchmarksFormatsRequestPost>
    >,
    TError,
    RequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof requestBenchmarkFormatApiBenchmarksFormatsRequestPost>
      >,
      RequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return requestBenchmarkFormatApiBenchmarksFormatsRequestPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof requestBenchmarkFormatApiBenchmarksFormatsRequestPost>
    >
  >;
export type RequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationBody =
  BenchmarkFormatRequest;
export type RequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationError =
  ErrorType<HTTPValidationError>;
export type RequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationVariables =
  { data: BenchmarkFormatRequest };

/**
 * @summary Request Benchmark Format
 */
export const useRequestBenchmarkFormatApiBenchmarksFormatsRequestPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof requestBenchmarkFormatApiBenchmarksFormatsRequestPost>
      >,
      TError,
      RequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof requestBenchmarkFormatApiBenchmarksFormatsRequestPost>
  >,
  TError,
  RequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationVariables,
  TContext
> => {
  return useMutation(
    getRequestBenchmarkFormatApiBenchmarksFormatsRequestPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type listBenchmarkAdaptersApiBenchmarksAdaptersGetResponse200 = {
  data: BenchmarkAdaptersResponse;
  status: 200;
};

export type listBenchmarkAdaptersApiBenchmarksAdaptersGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listBenchmarkAdaptersApiBenchmarksAdaptersGetResponseSuccess =
  listBenchmarkAdaptersApiBenchmarksAdaptersGetResponse200 & {
    headers: Headers;
  };
export type listBenchmarkAdaptersApiBenchmarksAdaptersGetResponseError =
  listBenchmarkAdaptersApiBenchmarksAdaptersGetResponse422 & {
    headers: Headers;
  };

export type listBenchmarkAdaptersApiBenchmarksAdaptersGetResponse =
  | listBenchmarkAdaptersApiBenchmarksAdaptersGetResponseSuccess
  | listBenchmarkAdaptersApiBenchmarksAdaptersGetResponseError;

export const getListBenchmarkAdaptersApiBenchmarksAdaptersGetUrl = () => {
  return `/api/benchmarks/adapters`;
};

/**
 * The TaskHopper adapters a team's benchmark can be run by (TRA-1279):
 * the adapter select on the staff Evals config page. Staff only.
 *
 * Static: the API image ships no adapter directory, so the list is the
 * API's copy of `training/taskhopper/adapters/`, held to it by a test.
 * @summary List Benchmark Adapters
 */
export const listBenchmarkAdaptersApiBenchmarksAdaptersGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listBenchmarkAdaptersApiBenchmarksAdaptersGetResponse> => {
  return orvalFetch<listBenchmarkAdaptersApiBenchmarksAdaptersGetResponse>(
    getListBenchmarkAdaptersApiBenchmarksAdaptersGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListBenchmarkAdaptersApiBenchmarksAdaptersGetQueryKey = () => {
  return [`/api/benchmarks/adapters`] as const;
};

export const getListBenchmarkAdaptersApiBenchmarksAdaptersGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListBenchmarkAdaptersApiBenchmarksAdaptersGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>>
  > = ({ signal }) =>
    listBenchmarkAdaptersApiBenchmarksAdaptersGet({
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBenchmarkAdaptersApiBenchmarksAdaptersGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>>
  >;
export type ListBenchmarkAdaptersApiBenchmarksAdaptersGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListBenchmarkAdaptersApiBenchmarksAdaptersGet<
  TData = Awaited<
    ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListBenchmarkAdaptersApiBenchmarksAdaptersGet<
  TData = Awaited<
    ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListBenchmarkAdaptersApiBenchmarksAdaptersGet<
  TData = Awaited<
    ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Benchmark Adapters
 */

export function useListBenchmarkAdaptersApiBenchmarksAdaptersGet<
  TData = Awaited<
    ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBenchmarkAdaptersApiBenchmarksAdaptersGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListBenchmarkAdaptersApiBenchmarksAdaptersGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createGithubBenchmarkApiBenchmarksGithubPostResponse201 = {
  data: GithubBenchmarkResponse;
  status: 201;
};

export type createGithubBenchmarkApiBenchmarksGithubPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createGithubBenchmarkApiBenchmarksGithubPostResponseSuccess =
  createGithubBenchmarkApiBenchmarksGithubPostResponse201 & {
    headers: Headers;
  };
export type createGithubBenchmarkApiBenchmarksGithubPostResponseError =
  createGithubBenchmarkApiBenchmarksGithubPostResponse422 & {
    headers: Headers;
  };

export type createGithubBenchmarkApiBenchmarksGithubPostResponse =
  | createGithubBenchmarkApiBenchmarksGithubPostResponseSuccess
  | createGithubBenchmarkApiBenchmarksGithubPostResponseError;

export const getCreateGithubBenchmarkApiBenchmarksGithubPostUrl = () => {
  return `/api/benchmarks/github`;
};

/**
 * Add a benchmark read from a GitHub repository (TRA-1279). Staff only.
 *
 * The repository is checked against the team's GitHub App installation
 * now, so the caller gets the real refusal. The entry lands on the
 * team's config row, and its eval group is created at once with the
 * body the daily inventory upserts (TRA-1356): the Evals page shows the
 * empty group right away, and the import later fills the same slug with
 * tasks. The inventory runs once staff turn the team's jobs on, and the
 * night scores the group once staff turn scoring on. Both switches stay
 * staff-owned, so #platform is told.
 * @summary Create Github Benchmark
 */
export const createGithubBenchmarkApiBenchmarksGithubPost = async (
  githubBenchmarkCreate: GithubBenchmarkCreate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createGithubBenchmarkApiBenchmarksGithubPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createGithubBenchmarkApiBenchmarksGithubPostResponse>(
    getCreateGithubBenchmarkApiBenchmarksGithubPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(githubBenchmarkCreate),
    },
  );
};

export const getCreateGithubBenchmarkApiBenchmarksGithubPostMutationKey = () =>
  ["createGithubBenchmarkApiBenchmarksGithubPost"] as const;

export const getCreateGithubBenchmarkApiBenchmarksGithubPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGithubBenchmarkApiBenchmarksGithubPost>>,
    TError,
    CreateGithubBenchmarkApiBenchmarksGithubPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGithubBenchmarkApiBenchmarksGithubPost>>,
  TError,
  CreateGithubBenchmarkApiBenchmarksGithubPostMutationVariables,
  TContext
> => {
  const mutationKey =
    getCreateGithubBenchmarkApiBenchmarksGithubPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGithubBenchmarkApiBenchmarksGithubPost>>,
    CreateGithubBenchmarkApiBenchmarksGithubPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createGithubBenchmarkApiBenchmarksGithubPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGithubBenchmarkApiBenchmarksGithubPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createGithubBenchmarkApiBenchmarksGithubPost>>
  >;
export type CreateGithubBenchmarkApiBenchmarksGithubPostMutationBody =
  GithubBenchmarkCreate;
export type CreateGithubBenchmarkApiBenchmarksGithubPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateGithubBenchmarkApiBenchmarksGithubPostMutationVariables = {
  data: GithubBenchmarkCreate;
};

/**
 * @summary Create Github Benchmark
 */
export const useCreateGithubBenchmarkApiBenchmarksGithubPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createGithubBenchmarkApiBenchmarksGithubPost>>,
      TError,
      CreateGithubBenchmarkApiBenchmarksGithubPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createGithubBenchmarkApiBenchmarksGithubPost>>,
  TError,
  CreateGithubBenchmarkApiBenchmarksGithubPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateGithubBenchmarkApiBenchmarksGithubPostMutationOptions(options),
    queryClient,
  );
};
export type createIngestionApiBenchmarksIngestionsPostResponse201 = {
  data: BenchmarkIngestionResponse;
  status: 201;
};

export type createIngestionApiBenchmarksIngestionsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createIngestionApiBenchmarksIngestionsPostResponseSuccess =
  createIngestionApiBenchmarksIngestionsPostResponse201 & {
    headers: Headers;
  };
export type createIngestionApiBenchmarksIngestionsPostResponseError =
  createIngestionApiBenchmarksIngestionsPostResponse422 & {
    headers: Headers;
  };

export type createIngestionApiBenchmarksIngestionsPostResponse =
  | createIngestionApiBenchmarksIngestionsPostResponseSuccess
  | createIngestionApiBenchmarksIngestionsPostResponseError;

export const getCreateIngestionApiBenchmarksIngestionsPostUrl = () => {
  return `/api/benchmarks/ingestions`;
};

/**
 * Validate S3 connectivity and queue a benchmark ingestion (TRA-922).
 * Staff only.
 *
 * The connectivity check runs NOW so the caller gets the real AWS
 * failure (can't assume role, AccessDenied, empty path). On success the
 * row is created as ``processing`` and the benchmark-ingest CronJob does
 * the actual S3→GCS ETL.
 * @summary Create Ingestion
 */
export const createIngestionApiBenchmarksIngestionsPost = async (
  benchmarkIngestionCreate: BenchmarkIngestionCreate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createIngestionApiBenchmarksIngestionsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createIngestionApiBenchmarksIngestionsPostResponse>(
    getCreateIngestionApiBenchmarksIngestionsPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(benchmarkIngestionCreate),
    },
  );
};

export const getCreateIngestionApiBenchmarksIngestionsPostMutationKey = () =>
  ["createIngestionApiBenchmarksIngestionsPost"] as const;

export const getCreateIngestionApiBenchmarksIngestionsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createIngestionApiBenchmarksIngestionsPost>>,
    TError,
    CreateIngestionApiBenchmarksIngestionsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createIngestionApiBenchmarksIngestionsPost>>,
  TError,
  CreateIngestionApiBenchmarksIngestionsPostMutationVariables,
  TContext
> => {
  const mutationKey =
    getCreateIngestionApiBenchmarksIngestionsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createIngestionApiBenchmarksIngestionsPost>>,
    CreateIngestionApiBenchmarksIngestionsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createIngestionApiBenchmarksIngestionsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateIngestionApiBenchmarksIngestionsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createIngestionApiBenchmarksIngestionsPost>>
  >;
export type CreateIngestionApiBenchmarksIngestionsPostMutationBody =
  BenchmarkIngestionCreate;
export type CreateIngestionApiBenchmarksIngestionsPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateIngestionApiBenchmarksIngestionsPostMutationVariables = {
  data: BenchmarkIngestionCreate;
};

/**
 * @summary Create Ingestion
 */
export const useCreateIngestionApiBenchmarksIngestionsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createIngestionApiBenchmarksIngestionsPost>>,
      TError,
      CreateIngestionApiBenchmarksIngestionsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createIngestionApiBenchmarksIngestionsPost>>,
  TError,
  CreateIngestionApiBenchmarksIngestionsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateIngestionApiBenchmarksIngestionsPostMutationOptions(options),
    queryClient,
  );
};
export type renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponse200 = {
  data: BenchmarkRenameResponse;
  status: 200;
};

export type renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponseSuccess =
  renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponse200 & {
    headers: Headers;
  };
export type renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponseError =
  renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponse422 & {
    headers: Headers;
  };

export type renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponse =
  | renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponseSuccess
  | renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponseError;

export const getRenameBenchmarkApiBenchmarksBenchmarkSlugPatchUrl = (
  benchmarkSlug: string,
) => {
  return `/api/benchmarks/${benchmarkSlug}`;
};

/**
 * Retitle a benchmark (TRA-947) — the label only, never the slug.
 *
 * A benchmark's name lives in two places over its life: on the
 * ``benchmark_ingestion`` row while the (days-long) analysis runs, and in
 * ``manifest.json`` once the ETL publishes. Both get written where they
 * exist — renaming only the row would be silently undone when the ETL
 * stamps the manifest from it, and renaming only the manifest would leave
 * a stale name on the processing card.
 *
 * The slug is untouched: it is the bucket prefix segment and every
 * benchmark URL, so this stays a pure relabel with nothing to move.
 *
 * Ceiling: console-exported benchmarks (no ingestion row) get the
 * manifest rewritten, so re-running that exporter overwrites the rename.
 * Self-serve ones survive re-ingest because the ETL stamps the manifest
 * from the row this also updates. Fix the exporter if that bites.
 * @summary Rename Benchmark
 */
export const renameBenchmarkApiBenchmarksBenchmarkSlugPatch = async (
  benchmarkSlug: string,
  benchmarkRename: BenchmarkRename,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<renameBenchmarkApiBenchmarksBenchmarkSlugPatchResponse>(
    getRenameBenchmarkApiBenchmarksBenchmarkSlugPatchUrl(benchmarkSlug),
    {
      ...options,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(benchmarkRename),
    },
  );
};

export const getRenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationKey =
  () => ["renameBenchmarkApiBenchmarksBenchmarkSlugPatch"] as const;

export const getRenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof renameBenchmarkApiBenchmarksBenchmarkSlugPatch>
      >,
      TError,
      RenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof renameBenchmarkApiBenchmarksBenchmarkSlugPatch>>,
    TError,
    RenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof renameBenchmarkApiBenchmarksBenchmarkSlugPatch>
      >,
      RenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationVariables
    > = (props) => {
      const { benchmarkSlug, data } = props ?? {};

      return renameBenchmarkApiBenchmarksBenchmarkSlugPatch(
        benchmarkSlug,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof renameBenchmarkApiBenchmarksBenchmarkSlugPatch>>
  >;
export type RenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationBody =
  BenchmarkRename;
export type RenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationError =
  ErrorType<HTTPValidationError>;
export type RenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationVariables = {
  benchmarkSlug: string;
  data: BenchmarkRename;
};

/**
 * @summary Rename Benchmark
 */
export const useRenameBenchmarkApiBenchmarksBenchmarkSlugPatch = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof renameBenchmarkApiBenchmarksBenchmarkSlugPatch>
      >,
      TError,
      RenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof renameBenchmarkApiBenchmarksBenchmarkSlugPatch>>,
  TError,
  RenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationVariables,
  TContext
> => {
  return useMutation(
    getRenameBenchmarkApiBenchmarksBenchmarkSlugPatchMutationOptions(options),
    queryClient,
  );
};
export type getBenchmarkApiBenchmarksBenchmarkSlugGetResponse200 = {
  data: BenchmarkDetailResponse;
  status: 200;
};

export type getBenchmarkApiBenchmarksBenchmarkSlugGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getBenchmarkApiBenchmarksBenchmarkSlugGetResponseSuccess =
  getBenchmarkApiBenchmarksBenchmarkSlugGetResponse200 & {
    headers: Headers;
  };
export type getBenchmarkApiBenchmarksBenchmarkSlugGetResponseError =
  getBenchmarkApiBenchmarksBenchmarkSlugGetResponse422 & {
    headers: Headers;
  };

export type getBenchmarkApiBenchmarksBenchmarkSlugGetResponse =
  | getBenchmarkApiBenchmarksBenchmarkSlugGetResponseSuccess
  | getBenchmarkApiBenchmarksBenchmarkSlugGetResponseError;

export const getGetBenchmarkApiBenchmarksBenchmarkSlugGetUrl = (
  benchmarkSlug: string,
) => {
  return `/api/benchmarks/${benchmarkSlug}`;
};

/**
 * The whole analysis page payload: manifest + tasks + scores +
 * failure attributions ([] when no classification export exists).
 * @summary Get Benchmark
 */
export const getBenchmarkApiBenchmarksBenchmarkSlugGet = async (
  benchmarkSlug: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getBenchmarkApiBenchmarksBenchmarkSlugGetResponse> => {
  return orvalFetch<getBenchmarkApiBenchmarksBenchmarkSlugGetResponse>(
    getGetBenchmarkApiBenchmarksBenchmarkSlugGetUrl(benchmarkSlug),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBenchmarkApiBenchmarksBenchmarkSlugGetQueryKey = (
  benchmarkSlug: string,
) => {
  return [`/api/benchmarks/${benchmarkSlug}`] as const;
};

export const getGetBenchmarkApiBenchmarksBenchmarkSlugGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBenchmarkApiBenchmarksBenchmarkSlugGetQueryKey(benchmarkSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>
  > = ({ signal }) =>
    getBenchmarkApiBenchmarksBenchmarkSlugGet(benchmarkSlug, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: benchmarkSlug !== null && benchmarkSlug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBenchmarkApiBenchmarksBenchmarkSlugGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>
>;
export type GetBenchmarkApiBenchmarksBenchmarkSlugGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetBenchmarkApiBenchmarksBenchmarkSlugGet<
  TData = Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
          TError,
          Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBenchmarkApiBenchmarksBenchmarkSlugGet<
  TData = Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
          TError,
          Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBenchmarkApiBenchmarksBenchmarkSlugGet<
  TData = Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Benchmark
 */

export function useGetBenchmarkApiBenchmarksBenchmarkSlugGet<
  TData = Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBenchmarkApiBenchmarksBenchmarkSlugGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBenchmarkApiBenchmarksBenchmarkSlugGetQueryOptions(
    benchmarkSlug,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponse200 =
  {
    data: TaskProcessResponse;
    status: 200;
  };

export type getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponseSuccess =
  getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponse200 & {
    headers: Headers;
  };
export type getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponseError =
  getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponse422 & {
    headers: Headers;
  };

export type getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponse =
  | getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponseSuccess
  | getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponseError;

export const getGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetUrl =
  (benchmarkSlug: string, taskSlug: string) => {
    return `/api/benchmarks/${benchmarkSlug}/process/${taskSlug}`;
  };

/**
 * The task's golden-process analysis: canonical steps, per-step
 * aggregates and reward correlations, and every analyzed rollout with
 * its step runs. 404 when the benchmark ships no analysis for the task
 * — the UI hides the timeline then. Opening it is recorded in the
 * team's audit log (TRA-1626).
 * @summary Get Task Process
 */
export const getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet =
  async (
    benchmarkSlug: string,
    taskSlug: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponse> => {
    return orvalFetch<getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetResponse>(
      getGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetUrl(
        benchmarkSlug,
        taskSlug,
      ),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetQueryKey =
  (benchmarkSlug: string, taskSlug: string) => {
    return [`/api/benchmarks/${benchmarkSlug}/process/${taskSlug}`] as const;
  };

export const getGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    benchmarkSlug: string,
    taskSlug: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetQueryKey(
        benchmarkSlug,
        taskSlug,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
        >
      >
    > = ({ signal }) =>
      getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet(
        benchmarkSlug,
        taskSlug,
        { signal, ...requestOptions },
      );

    return {
      queryKey,
      queryFn,
      enabled:
        benchmarkSlug !== null &&
        benchmarkSlug !== undefined &&
        taskSlug !== null &&
        taskSlug !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
      >
    >
  >;
export type GetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet<
  TData = Awaited<
    ReturnType<
      typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet<
  TData = Awaited<
    ReturnType<
      typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet<
  TData = Awaited<
    ReturnType<
      typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Task Process
 */

export function useGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet<
  TData = Awaited<
    ReturnType<
      typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTaskProcessApiBenchmarksBenchmarkSlugProcessTaskSlugGetQueryOptions(
      benchmarkSlug,
      taskSlug,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponse200 =
  {
    data: RolloutListResponse;
    status: 200;
  };

export type listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponseSuccess =
  listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponse200 & {
    headers: Headers;
  };
export type listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponseError =
  listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponse422 & {
    headers: Headers;
  };

export type listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponse =
  | listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponseSuccess
  | listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponseError;

export const getListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetUrl = (
  benchmarkSlug: string,
  taskSlug: string,
) => {
  return `/api/benchmarks/${benchmarkSlug}/rollouts/${taskSlug}`;
};

/**
 * Every rollout for a task across models, scored for the strip,
 * plus per-criterion pass rates aggregated across those rollouts. The
 * criteria carry a grader's rationale, so the read is recorded in the
 * team's audit log (TRA-1626).
 * @summary List Rollouts
 */
export const listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet = async (
  benchmarkSlug: string,
  taskSlug: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponse> => {
  return orvalFetch<listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetResponse>(
    getListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetUrl(
      benchmarkSlug,
      taskSlug,
    ),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetQueryKey =
  (benchmarkSlug: string, taskSlug: string) => {
    return [`/api/benchmarks/${benchmarkSlug}/rollouts/${taskSlug}`] as const;
  };

export const getListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    benchmarkSlug: string,
    taskSlug: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetQueryKey(
        benchmarkSlug,
        taskSlug,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
        >
      >
    > = ({ signal }) =>
      listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet(
        benchmarkSlug,
        taskSlug,
        { signal, ...requestOptions },
      );

    return {
      queryKey,
      queryFn,
      enabled:
        benchmarkSlug !== null &&
        benchmarkSlug !== undefined &&
        taskSlug !== null &&
        taskSlug !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
      >
    >
  >;
export type ListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet<
  TData = Awaited<
    ReturnType<typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet<
  TData = Awaited<
    ReturnType<typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet<
  TData = Awaited<
    ReturnType<typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Rollouts
 */

export function useListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet<
  TData = Awaited<
    ReturnType<typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListRolloutsApiBenchmarksBenchmarkSlugRolloutsTaskSlugGetQueryOptions(
      benchmarkSlug,
      taskSlug,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponse200 =
  {
    data: RolloutDetailResponse;
    status: 200;
  };

export type getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponseSuccess =
  getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponse200 & {
    headers: Headers;
  };
export type getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponseError =
  getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponse422 & {
    headers: Headers;
  };

export type getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponse =

    | getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponseSuccess
    | getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponseError;

export const getGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetUrl =
  (
    benchmarkSlug: string,
    taskSlug: string,
    model: string,
    rolloutId: string,
  ) => {
    return `/api/benchmarks/${benchmarkSlug}/rollouts/${taskSlug}/${model}/${rolloutId}`;
  };

/**
 * One rollout: trajectory + grades (+ diagnosis when present).
 * Opening one is recorded in the team's audit log (TRA-1626).
 * @summary Get Rollout
 */
export const getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet =
  async (
    benchmarkSlug: string,
    taskSlug: string,
    model: string,
    rolloutId: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponse> => {
    return orvalFetch<getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetResponse>(
      getGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetUrl(
        benchmarkSlug,
        taskSlug,
        model,
        rolloutId,
      ),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetQueryKey =
  (
    benchmarkSlug: string,
    taskSlug: string,
    model: string,
    rolloutId: string,
  ) => {
    return [
      `/api/benchmarks/${benchmarkSlug}/rollouts/${taskSlug}/${model}/${rolloutId}`,
    ] as const;
  };

export const getGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    benchmarkSlug: string,
    taskSlug: string,
    model: string,
    rolloutId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetQueryKey(
        benchmarkSlug,
        taskSlug,
        model,
        rolloutId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
        >
      >
    > = ({ signal }) =>
      getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet(
        benchmarkSlug,
        taskSlug,
        model,
        rolloutId,
        { signal, ...requestOptions },
      );

    return {
      queryKey,
      queryFn,
      enabled:
        benchmarkSlug !== null &&
        benchmarkSlug !== undefined &&
        taskSlug !== null &&
        taskSlug !== undefined &&
        model !== null &&
        model !== undefined &&
        rolloutId !== null &&
        rolloutId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
      >
    >
  >;
export type GetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  model: string,
  rolloutId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  model: string,
  rolloutId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  model: string,
  rolloutId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Rollout
 */

export function useGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  benchmarkSlug: string,
  taskSlug: string,
  model: string,
  rolloutId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetRolloutApiBenchmarksBenchmarkSlugRolloutsTaskSlugModelRolloutIdGetQueryOptions(
      benchmarkSlug,
      taskSlug,
      model,
      rolloutId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
